<template>
  <h3 class="judul-seksi-sga">Tahun Ajaran</h3>
  <hr>
  <form>
    <div class="form-general">
      <div class="row">
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.tahunajaranpsb.$error?'text-danger':''">Nama Tahun Ajaran PSB</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.tahunajaranpsb" placeholder="misalkan: 2025/2026" class="w-100 form-control" maxlength="9">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.tahunajaransaatini.$error?'text-danger':''">Nama Tahun Ajaran Saat ini</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.tahunajaransaatini" placeholder="misalkan: 2025/2026" class="w-100 form-control" maxlength="9">
        </div>

        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.ketuatimpsb.$error?'text-danger':''">Ketua tim PSB</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.ketuatimpsb" placeholder="misalnya Jasmin Jasin" class="w-100 form-control" maxlength="50">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.kepalasekolah.$error?'text-danger':''">Nama Kepala Sekolah</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.kepalasekolah" placeholder="misalnya Jasmin Jasin" class="w-100 form-control" maxlength="50">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.tenggatwaktubayar.$error?'text-danger':''">Tenggat waktu pembayaran penuh</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <input type="date" v-model="dataParameter.tenggatwaktubayar" placeholder="" class="w-100 form-control" maxlength="10">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.pengambilanseragam.$error?'text-danger':''">Waktu pengambilan seragam</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.pengambilanseragam" placeholder="" class="w-100 form-control" maxlength="100">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.pembelianseragam.$error?'text-danger':''">Waktu pembelian seragam</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.pembelianseragam" placeholder="" class="w-100 form-control" maxlength="100">
        </div>


        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.kapasitas.kelas1.$error?'text-danger':''">Kapasitas kelas 1</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.kapasitas.kelas1" placeholder="masukkan angka" class="w-100 form-control" @keypress="onInput($event,3)" maxlength="3">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.kapasitas.kelas1pindahan.$error?'text-danger':''">Kapasitas kelas 1 pindahan</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.kapasitas.kelas1pindahan" placeholder="masukkan angka" class="w-100 form-control" @keypress="onInput($event,3)" maxlength="3">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.kapasitas.kelas2.$error?'text-danger':''">Kapasitas kelas 2</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.kapasitas.kelas2" placeholder="masukkan angka" class="w-100 form-control" @keypress="onInput($event,3)" maxlength="3">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.kapasitas.kelas3.$error?'text-danger':''">Kapasitas kelas 3</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.kapasitas.kelas3" placeholder="masukkan angka" class="w-100 form-control" @keypress="onInput($event,3)" maxlength="3">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.kapasitas.kelas4.$error?'text-danger':''">Kapasitas kelas 4</label></div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.kapasitas.kelas4" placeholder="masukkan angka" class="w-100 form-control" @keypress="onInput($event,3)" maxlength="3">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.kapasitas.kelas5.$error?'text-danger':''">Kapasitas kelas 5</label></div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.kapasitas.kelas5" placeholder="masukkan angka" class="w-100 form-control" @keypress="onInput($event,3)" maxlength="3">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.kapasitas.kelas6.$error?'text-danger':''">Kapasitas kelas 6</label></div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.kapasitas.kelas6" placeholder="masukkan angka" class="w-100 form-control" @keypress="onInput($event,3)" maxlength="3">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.maxberkas.$error?'text-danger':''">Maksimal berkas masuk</label></div>
        <div class="col-md-6 spacer-field-sga">
          <input type="text" v-model="dataParameter.maxberkas" placeholder="masukkan angka" class="w-100 form-control" @keypress="onInput($event,3)" maxlength="3">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.biaya.formulir.$error?'text-danger':''">Biaya formulir pendaftaran (Rp)</label></div>
        <div class="col-md-6 spacer-field-sga">
          <InputNumber type="number" v-model="dataParameter.biaya.formulir"
                       placeholder="masukkan angka" class="w-100 form-control"
                       @keypress="onInput($event,30)" maxlength="9"
                       minFractionDigits=0 maxFractionDigits=0
                       mode="currency" currency="IDR" currencyDisplay="symbol" locale="en-ID" fluid
          />
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.biaya.konfirmasi.$error?'text-danger':''">Tanda konfirmasi pendaftaran (Rp)</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <InputNumber type="number" v-model="dataParameter.biaya.konfirmasi"
                       placeholder="masukkan angka" class="w-100 form-control"
                       @keypress="onInput($event,30)" maxlength="9"
                       minFractionDigits=0 maxFractionDigits=0
                       mode="currency" currency="IDR" currencyDisplay="symbol" locale="en-ID" fluid
          />
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.uang.pengembangan.$error?'text-danger':''">Uang pengembangan (Rp)</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <InputNumber type="number" v-model="dataParameter.uang.pengembangan"
                       placeholder="masukkan angka" class="w-100 form-control"
                       @keypress="onInput($event,30)" maxlength="9"
                       minFractionDigits=0 maxFractionDigits=0
                       mode="currency" currency="IDR" currencyDisplay="symbol" locale="en-ID" fluid
          />
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.uang.sekolah.$error?'text-danger':''">Uang sekolah (Rp)</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <InputNumber type="number" v-model="dataParameter.uang.sekolah"
                       placeholder="masukkan angka" class="w-100 form-control"
                       @keypress="onInput($event,30)" maxlength="9"
                       minFractionDigits=0 maxFractionDigits=0
                       mode="currency" currency="IDR" currencyDisplay="symbol" locale="en-ID" fluid
          />
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.diskon.pengembangansibling.$error?'text-danger':''">Diskon uang pengembangan sibling (Rp)</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <InputNumber type="number" v-model="dataParameter.diskon.pengembangansibling"
                       placeholder="masukkan angka" class="w-100 form-control"
                       @keypress="onInput($event,30)" maxlength="9"
                       minFractionDigits=0 maxFractionDigits=0
                       mode="currency" currency="IDR" currencyDisplay="symbol" locale="en-ID" fluid
          />
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.diskon.sibling.$error?'text-danger':''">Diskon uang sekolah sibling (Rp)</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <InputNumber type="number" v-model="dataParameter.diskon.sibling"
                       placeholder="masukkan angka" class="w-100 form-control"
                       @keypress="onInput($event,30)" maxlength="9"
                       minFractionDigits=0 maxFractionDigits=0
                       mode="currency" currency="IDR" currencyDisplay="symbol" locale="en-ID" fluid
          />
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.diskon.pengembangankartap.$error?'text-danger':''">Diskon uang pengembangan karyawan tetap (Rp)</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <InputNumber type="number" v-model="dataParameter.diskon.pengembangankartap"
                       placeholder="masukkan angka" class="w-100 form-control"
                       @keypress="onInput($event,30)" maxlength="9"
                       minFractionDigits=0 maxFractionDigits=0
                       mode="currency" currency="IDR" currencyDisplay="symbol" locale="en-ID" fluid
          />
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.diskon.kartap.$error?'text-danger':''">Diskon uang sekolah karyawan tetap (Rp)</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <InputNumber type="number" v-model="dataParameter.diskon.kartap"
                       placeholder="masukkan angka" class="w-100 form-control"
                       @keypress="onInput($event,30)" maxlength="9"
                       minFractionDigits=0 maxFractionDigits=0
                       mode="currency" currency="IDR" currencyDisplay="symbol" locale="en-ID" fluid
          />
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.diskon.pengembanganparuhwaktu.$error?'text-danger':''">Diskon uang pengembangan karyawan paruh waktu (Rp)</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <InputNumber type="number" v-model="dataParameter.diskon.pengembanganparuhwaktu"
                       placeholder="masukkan angka" class="w-100 form-control"
                       @keypress="onInput($event,30)" maxlength="9"
                       minFractionDigits=0 maxFractionDigits=0
                       mode="currency" currency="IDR" currencyDisplay="symbol" locale="en-ID" fluid
          />
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.diskon.paruhwaktu.$error?'text-danger':''">Diskon uang sekolah karyawan paruh waktu (Rp)</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <InputNumber type="number" v-model="dataParameter.diskon.paruhwaktu"
                       placeholder="masukkan angka" class="w-100 form-control"
                       @keypress="onInput($event,30)" maxlength="9"
                       minFractionDigits=0 maxFractionDigits=0
                       mode="currency" currency="IDR" currencyDisplay="symbol" locale="en-ID" fluid
          />
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.diskon.khusus.$error?'text-danger':''">Diskon Khusus (Rp)</label>
        </div>
        <div class="col-md-6 spacer-field-sga">
          <InputNumber type="number" v-model="dataParameter.diskon.khusus"
                       placeholder="masukkan angka" class="w-100 form-control"
                       @keypress="onInput($event,30)" maxlength="9"
                       minFractionDigits=0 maxFractionDigits=0
                       mode="currency" currency="IDR" currencyDisplay="symbol" locale="en-ID" fluid
          />
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.waktubuka.$error?'text-danger':''">Waktu pembukaan pendaftaran</label>
        </div>
        <div class="col-md-3 spacer-field-sga">
          <input type="date" v-model="dataParameter.waktubuka.tanggal" placeholder="dd/mm/yy" class="w-100 form-control">
        </div>
        <div class="col-md-3 spacer-field-sga">
          <input type="time" v-model="dataParameter.waktubuka.waktu" placeholder="h:i" class="w-100 form-control">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.waktututup.$error?'text-danger':''">Waktu penutupan pendaftaran</label>
        </div>
        <div class="col-md-3 spacer-field-sga">
          <input type="date" v-model="dataParameter.waktututup.tanggal" placeholder="dd/mm/yy" class="w-100 form-control">
        </div>
        <div class="col-md-3 spacer-field-sga">
          <input type="time" v-model="dataParameter.waktututup.waktu" placeholder="h:i" class="w-100 form-control">
        </div>
        <div class="col-md-6 spacer-field-sga">
          <label :class="v$.dataParameter.tahunajaranaktif.$error?'text-danger':''">Adalah tahun ajaran aktif</label><br>
          <keterangan-form>Hanya satu tahun ajaran yang dapat memiliki status aktif, mengubah
            status tahun ajaran akan mengubah status tahun ajaran yang lain
          </keterangan-form>
        </div>
        <div class="col-md-3 spacer-field-sga">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" v-model="dataParameter.tahunajaranaktif" name="inlineRadioOptions" id="inlineRadio1" value="Ya">
            <normal-label2 class="form-check-label" for="inlineRadio1">Ya</normal-label2>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" v-model="dataParameter.tahunajaranaktif" name="inlineRadioOptions" id="inlineRadio2" value="Tidak">
            <normal-label2 class="form-check-label" for="inlineRadio2">Tidak</normal-label2>
          </div>
        </div>
        <div class="col-12" v-if="messagetrx">
          <AlertSuccess v-if="successtrx" :message="messagetrx"></AlertSuccess>
          <AlertDanger v-else :message="messagetrx"></AlertDanger>
        </div>
        <ConfirmDialog></ConfirmDialog>
        <div class="col-12 button-area-sga text-right"><button type="button" @click="konfirmasi" class="btn btn-md btn-success"><i
            class="fa-solid fa-caret-right"></i> Simpan</button></div>
      </div>
    </div>
  </form>
</template>

<script>
import useValidate from '@vuelidate/core'
import {required, numeric} from '@vuelidate/validators'
import DashboardServices from "@/services/dashboard.services";
import ConfirmDialog from 'primevue/confirmdialog';
import AlertDanger from "@/components/AlertDanger";
import AlertSuccess from "@/components/AlertSuccess";
import tools from "@/js/js.function.tools";
import InputNumber from 'primevue/inputnumber';
export default {
  name: "PageParameterTahunAjaran",
  props:{dataPeriode:undefined},
  components:{
    AlertSuccess,
    AlertDanger,
    ConfirmDialog,
    InputNumber
  },
  data:()=>({
    v$: useValidate(),
    success: false,
    successtrx: false,
    loading: false,
    message:'',
    messagetrx:'',
    error:'',
    dataParameter:{
      tahunajaranpsb:'',
      tahunajaransaatini:'',
      ketuatimpsb:'',
      kepalasekolah:'',
      tenggatwaktubayar:'',
      pengambilanseragam:'',
      pembelianseragam:'',
      kapasitas:{
        kelas1:'',
        kelas1pindahan:'',
        kelas2:'',
        kelas3:'',
        kelas4:'',
        kelas5:'',
        kelas6:'',
      },
      maxberkas:'',
      biaya:{
        formulir:'',
        konfirmasi:'',
      },
      uang:{
        pengembangan:0,
        sekolah:0
      },
      diskon:{
        pengembangankartap:0,
        kartap:0,
        pengembanganparuhwaktu:0,
        paruhwaktu:0,
        pengembangansibling:0,
        sibling:0,
        khusus:0
      },
      waktubuka:{
        tanggal:'',
        waktu:''
      },
      waktututup:{
        tanggal:'',
        waktu:''
      },
      tahunajaranaktif:false
    }
  }),
  validations() {
    return {
      dataParameter:{
        tahunajaranpsb:{required},
        tahunajaransaatini:{required},
        ketuatimpsb:{},
        kepalasekolah:{},
        tenggatwaktubayar:{},
        pengambilanseragam:{},
        pembelianseragam:{},
        maxberkas: {required},
        kapasitas:{
          kelas1:{required,numeric},
          kelas1pindahan:{required,numeric},
          kelas2:{required,numeric},
          kelas3:{required,numeric},
          kelas4:{required,numeric},
          kelas5:{required,numeric},
          kelas6:{required,numeric},
        },
        biaya:{
          formulir:{required,numeric},
          konfirmasi:{required,numeric},
        },
        uang:{
          pengembangan:{required,numeric},
          sekolah:{required,numeric},
        },
        diskon:{
          pengembangankartap:{required,numeric},
          kartap:{required,numeric},
          pengembanganparuhwaktu:{required,numeric},
          paruhwaktu:{required,numeric},
          pengembangansibling:{required,numeric},
          sibling:{required,numeric},
          khusus:{required,numeric}
        },
        waktubuka:{
          tanggal: {required},
          waktu: {required}
        },
        waktututup:{
          tanggal: {required},
          waktu: {required}
        },
        tahunajaranaktif:{required}
      }
    }
  },
  methods:{
    onInput(evt, max) {
      tools.inputNumericOnly(evt, max);
    },
    async konfirmasi(){
      const result = await this.v$.dataParameter.$validate();
      if(result){
        this.$confirm.require({
          message: 'Apakah data yang Anda masukkan sudah benar?',
          header: 'Pengisian Formulir',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Ya',
          rejectLabel: 'Cek kembali',
          defaultFocus:'reject',
          accept: () => {
            this.doSubmitIsiFormulir();
          },
          reject: () => {
          }
        });
      }else{
        this.successtrx = false;
        this.messagetrx = 'Silahkan isi formulir dengan benar';
      }
    },
    async doSubmitIsiFormulir(){
      const result = await this.v$.dataParameter.$validate();
      if(result){
        this.error = false;
        this.loading = true;
        this.$store.commit('loading',this.loading);
        let data = this.dataParameter;
        let path = '/dashboard/saveParameterTahunAjaran';
        DashboardServices.postData(data,path).then(
            (response)=>{
              this.response = response.data;
              this.messagetrx = response.data.message;
              if(response.data.status===200){
                this.successtrx = true;
                this.error = false;
              }else {
                this.error = true;
                this.successtrx = false;
              }
              this.loading = false;
              this.$store.commit('loading',this.loading);
            }
        );
      }else{
        this.error = true;
        this.loading = false;
        this.successtrx = false;
        this.messagetrx = 'Mohon lengkapi data terlebih dahulu';
        this.$store.commit('loading',this.loading);
      }
    },
  },
  mounted() {
    if(this.dataPeriode != undefined){
      if(Object.keys( this.dataPeriode.data ).length !== 0){
        this.dataParameter = this.dataPeriode.data.view;
      }
    }
  },

}
</script>

<style scoped>

</style>